import { DocumentType } from "@/pages/configuracoes/subsellers/NewSubSeller";
import { cleanDocument, detectDocumentType, formatCnpjString, hasCnpjShape } from "./validateCnpj";

export function FormatDocument(document: string): string {
  const cleanedDocument = cleanDocument(document);

  if (detectDocumentType(cleanedDocument) === "CPF") {
    return cleanedDocument.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (cleanedDocument.length === 14) {
    return formatCnpjString(cleanedDocument);
  }
  return document;
}

export function maskDocumentForPrivacy(value?: string | null): string {
  if (!value) return "—";
  const clean = cleanDocument(String(value));
  if (/^\d{11}$/.test(clean)) return clean.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "**.$2.$3-**");
  if (hasCnpjShape(clean)) return clean.replace(/^([0-9A-Z]{2})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{4})(\d{2})$/, "**.$2.$3/$4-**");
  return "—";
}

export function ReturnDocumentType(document: string): DocumentType {
  return detectDocumentType(document) || "";
}
